import { IGNORE_ERRORS } from './IGNORE_ERRORS'

export const CLIENT_IGNORE_ERRORS = [
  ...IGNORE_ERRORS,
  /load failed/i,
  /failed to fetch/i,
  /fetch failed/i,
]
